var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40992 3.83681L2.30564 12.4561C2.28922 12.4873 2.28357 12.5231 2.28955 12.5579C2.29554 12.5927 2.31282 12.6245 2.33873 12.6484L13.4179 23.2702C13.4498 23.299 13.4912 23.3149 13.5341 23.3149C13.5771 23.3149 13.6185 23.299 13.6503 23.2702L24.7362 12.6484C24.7618 12.6243 24.7789 12.5925 24.7849 12.5578C24.7909 12.5231 24.7854 12.4874 24.7693 12.4561L20.665 3.83681C20.6541 3.80683 20.634 3.78106 20.6076 3.76316C20.5812 3.74527 20.5498 3.73617 20.5179 3.73716H6.55553C6.52407 3.73803 6.4935 3.74786 6.46744 3.76552C6.44139 3.78317 6.42092 3.80791 6.40845 3.83681H6.40992Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9634 13.3381C14.8839 13.3447 14.4729 13.3712 13.5576 13.3712C12.8285 13.3712 12.3111 13.3513 12.1254 13.3381C9.30775 13.2123 7.20596 12.7215 7.20596 12.1379C7.20596 11.5544 9.30775 11.0572 12.1254 10.9315V12.8476C12.3093 12.8608 12.8351 12.8939 13.5643 12.8939C14.4394 12.8939 14.877 12.8542 14.9567 12.8476V10.9315C17.7678 11.0572 19.8696 11.5481 19.8696 12.1313C19.8696 12.7145 17.7737 13.2123 14.9634 13.3381ZM14.9634 10.7392V9.02164H18.8886V6.40286H8.2006V9.02164H12.1254V10.7392C8.93637 10.8863 6.53638 11.5147 6.53638 12.2773C6.53638 13.0399 8.93637 13.6631 12.1254 13.8154V19.3121H14.9634V13.8154C18.1458 13.6683 20.5396 13.0395 20.5396 12.2839C20.5396 11.5283 18.1458 10.8848 14.9634 10.7395V10.7392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.636451721781bb4a82b3d164d5aa666c.svg";
export { ForwardRef as ReactComponent };